import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { WORKSPACE_URL } from "../../constants/links";

export default function FinalCta() {
  return (
    <section
      id="cta"
      data-testid="final-cta-section"
      className="relative py-28 sm:py-36 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.10] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage:
            "radial-gradient(ellipse 80% 60% at 50% 0%, #000 35%, transparent 90%)",
        }}
      />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 h-[420px] w-[1000px] rounded-[100%] bg-[#0044FF]/25 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 text-center">
        <motion.span
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.06] backdrop-blur px-3 py-1.5 mb-6"
        >
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
          <span className="font-mono text-[11px] tracking-[0.2em] text-white/80">
            START YOUR FIRST RFQ
          </span>
        </motion.span>

        <motion.h2
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-display font-black tracking-[-0.04em] text-[44px] sm:text-[72px] lg:text-[88px] leading-[0.95]"
        >
          Every successful import
          <br />
          <span className="text-white/40">starts with the right RFQ.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="mt-6 mx-auto max-w-2xl text-[15px] sm:text-[17px] leading-relaxed text-white/65"
        >
          Create one professional sourcing request, connect with verified Turkish
          manufacturers and manage every import operation inside one Workspace.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.18 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <a
            data-testid="final-create-rfq-btn"
            href={WORKSPACE_URL}
            className="inline-flex items-center gap-2 rounded-[10px] bg-white text-[#0A0A0A] font-semibold py-3.5 px-5 text-[14px] hover:bg-[#0044FF] hover:text-white transition-all shadow-[0_20px_40px_-15px_rgba(255,255,255,0.4)]"
          >
            Create Your RFQ™
            <ArrowUpRight className="h-4 w-4" strokeWidth={2.25} />
          </a>
          <a
            data-testid="final-create-workspace-btn"
            href={WORKSPACE_URL}
            className="inline-flex items-center gap-2 rounded-[10px] border border-white/15 bg-white/[0.04] text-white font-semibold py-3.5 px-5 text-[14px] hover:bg-white/[0.08] transition-all"
          >
            <Sparkles className="h-4 w-4" />
            Create Your Free Workspace
          </a>
        </motion.div>

        <p className="mt-8 font-mono text-[11px] tracking-[0.2em] text-white/45">
          FACTORY DIRECT QUOTATIONS · VERIFIED TURKISH MANUFACTURERS · NO PRODUCT MARKUPS
        </p>
      </div>
    </section>
  );
}
